export const DisclaimerText =
  'This navigation mode lets you view the customer experience. Some features and buttons will be disabled since you cannot perform actions for them.';
